import { render, staticRenderFns } from "./ProductProfileComponent.vue?vue&type=template&id=42ff858e&"
import script from "./ProductProfileComponent.vue?vue&type=script&lang=js&"
export * from "./ProductProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports